import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { AxiosResponse } from 'axios';
import {
  EmployeeVisibilitySetting,
  UpdateEmployeeVisibilityDto,
} from './CandidateVisibility.type';

const REQUEST_PREFIX = 'people/visibility';

export const candidateVisibilityService = {
  getList: (params?: {
    perPage?: number;
    page?: number;
  }): Promise<{ data: EmployeeVisibilitySetting[] }> => {
    return axios.get(getEndpointBase(REQUEST_PREFIX), { params });
  },

  update: (
    data: UpdateEmployeeVisibilityDto,
  ): Promise<AxiosResponse<{ data: EmployeeVisibilitySetting }>> => {
    return axios.put(getEndpointBase(REQUEST_PREFIX), data);
  },

  destroy: (employeeId: number): Promise<AxiosResponse<null>> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${employeeId}`));
  },
};
